import { gisProjects } from './project-lists'

export default (beforeEnter, wrapper) => {
  return {
    name: 'planning',
    path: 'planning',
    beforeEnter,
    redirect: 'explorer',
    component: wrapper,
    meta: {
      title: 'planning:title',
      icon: 'map',
      description: 'planning:desc'
    },
    children: [
      {
        name: 'gis',
        path: 'gis',
        beforeEnter,
        redirect: 'gis/main',
        component: wrapper,
        meta: {
          title: 'gis:module-title',
          abbr: 'gis:abbr-module-title',
          icon: 'geometry-instruments',
          description: 'gis:module-desc',
          endpoints: ['gis'],
          projects: [...gisProjects]
        },
        children: [
          {
            name: 'gis-main',
            path: 'main',
            beforeEnter,
            component: () => import('@/modules/gis/views/gis'),
            meta: {
              title: 'gis:module-title',
              abbr: 'gis:abbr-module-title',
              icon: 'geometry-instruments',
              description: 'gis:module-desc',
              isMap: true
            }
          },
          {
            name: 'gis-registry',
            path: 'registry',
            beforeEnter,
            component: () => import('@/modules/gis/views/gis-registry'),
            meta: {
              title: 'gis:module-title',
              abbr: 'gis:abbr-module-title',
              icon: 'geometry-instruments',
              subtitle: 'registry'
            }
          }
        ]
      },
      {
        name: 'ksodd-podd',
        path: 'ksodd',
        beforeEnter,
        component: wrapper,
        redirect: 'ksodd/ksodd',
        meta: {
          title: 'ksodd:title',
          abbr: 'ksodd:abbr-title',
          icon: 'globe',
          description: 'ksodd:desc',
          endpoints: ['ksodd'],
          projects: [
            'academic',
            'surgut',
            'eputs',
            'niipi',
            'demo',
            'vshe',
            'omsk',
            'urfu',
            'rut',
            'kdh'
          ]
        },
        children: [
          {
            name: 'ksodd',
            path: 'ksodd',
            beforeEnter,
            component: () => import('@/modules/ksodd/views/ksodd'),
            meta: {
              title: 'ksodd:title',
              abbr: 'ksodd:abbr-title',
              icon: 'globe',
              description: 'ksodd:desc',
              isMap: true
            }
          },
          {
            name: 'podd',
            path: 'podd',
            beforeEnter,
            component: () => import('@/modules/ksodd/views/podd'),
            meta: {
              title: 'ksodd:title',
              subtitle: 'ksood:podd-subtitle',
              abbr: 'ksodd:abbr-title',
              icon: 'globe',
              description: 'ksodd:desc',
              isMap: true
            }
          },
          {
            name: 'registry',
            path: 'registry/:id',
            beforeEnter,
            component: () => import('@/modules/ksodd/views/book'),
            meta: {
              title: 'ksodd:title',
              subtitle: 'ksood:ksodd-registry-subtitle',
              abbr: 'ksodd:abbr-title',
              icon: 'globe',
              description: 'ksodd:desc',
              isMap: true
            }
          }
        ]
      },
      {
        name: 'tsodd',
        path: 'tsodd',
        beforeEnter,
        component: wrapper,
        redirect: 'tsodd/selector',
        meta: {
          // dev_only: true,
          // admin_only: true,
          title: 'tsodd:title',
          abbr: 'tsodd:abbr-title',
          icon: 'road-sign',
          description: 'tsodd:desc',
          endpoints: ['tsodd'],
          projects: ['demo', 'eputs']
        },
        children: [
          {
            name: 'project-selector',
            path: 'selector',
            beforeEnter,
            component: () =>
              import('@/modules/tsodd/views/tsodd-project-selector'),
            meta: {
              title: 'tsodd:title',
              icon: 'road-sign',
              abbr: 'tsodd:abbr-title',
              description: 'tsodd:desc'
            }
          },
          {
            name: 'tsodd-project',
            path: 'project-view',
            beforeEnter,
            component: () => import('@/modules/tsodd/views/tsodd-project'),
            meta: {
              title: 'tsodd:title',
              icon: 'road-sign',
              abbr: 'tsodd:abbr-title',
              description: 'tsodd:desc'
            }
          },
          {
            name: 'tsodd-registry',
            path: 'registry',
            beforeEnter,
            component: () => import('@/modules/tsodd/views/tsodd-registry'),
            meta: {
              title: 'tsodd:title',
              subtitle: 'tsodd:registry_title',
              icon: 'road-sign',
              abbr: 'tsodd:abbr-title',
              description: 'tsodd:registry_desc'
            }
          },
          {
            name: 'tsodd-signs-editor-main',
            path: 'signs-editor-main',
            beforeEnter,
            component: () =>
              import('@/modules/tsodd/views/tsodd-signs-editor-main'),
            meta: {
              title: 'tsodd:title',
              subtitle: 'tsodd:registry_title',
              icon: 'road-sign',
              abbr: 'tsodd:abbr-title',
              description: 'tsodd:registry_desc'
            }
          },
          {
            name: 'tsodd-signs-viewer',
            path: 'signs-viewer',
            beforeEnter,
            component: () => import('@/modules/tsodd/views/tsodd-signs-viewer'),
            meta: {
              title: 'tsodd:title',
              subtitle: 'tsodd:registry_title',
              icon: 'road-sign',
              abbr: 'tsodd:abbr-title',
              description: 'tsodd:registry_desc'
            }
          },
          {
            name: 'tsodd-signs-editor-selector',
            path: 'signs-editor-selector',
            beforeEnter,
            component: () =>
              import('@/modules/tsodd/views/tsodd-signs-editor-selector'),
            meta: {
              title: 'tsodd:title',
              subtitle: 'tsodd:registry_title',
              icon: 'road-sign',
              abbr: 'tsodd:abbr-title',
              description: 'tsodd:registry_desc'
            }
          }
        ]
      }
    ]
  }
}
